import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getMarketTradeDetail = (payload) =>
  httpClient.get(
    apis.GET_MARKET_TRADE_DETAIL,
    //{ params: { qrId } }
    {
      params: {
        //studentId: 955,
        ...payload,
        //type: 'order',
        //id: 1211
      },
    }
  );
